import { render, staticRenderFns } from "./default.vue?vue&type=template&id=165fff18"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/home/headFoot.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./default.vue?vue&type=style&index=1&id=165fff18&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports